import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Input } from "../../../../components";
import AnimatedDots from "../../../../components/AnimatedDots/AnimatedDots";
import CircularIndeterminate from "../../../../components/circleLoader/CircleLoader";
import { AppRoutes } from "../../../../constants";
import { DonorSendOtp_V2 } from "../../../../Services_V2/Auth.service";
import { showError } from "../../../../utils/error";
import { ILoginInputs, LoginInputs, loginSchema } from "../const";
import styles from "./donor-login.module.css";

interface IProp {
  userType?: string;
}

const DonorLogin: React.FC<IProp> = ({ userType }) => {
  const navigation = useNavigate();
  const location = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ILoginInputs>({
    resolver: yupResolver(loginSchema),
  });

  const [loading, setLoading] = useState(false);
  const returnTo = (location.state as { returnTo?: string })?.returnTo;

  const onSubmit = useCallback(
    async (values: ILoginInputs) => {
      setLoading(true);
      try {
        const res = await DonorSendOtp_V2({
          email: values[LoginInputs.EMAIL],
        });

        const email = values[LoginInputs.EMAIL];
        sessionStorage.setItem("donorPendingEmail", email);

        navigation(AppRoutes.DONOR.DONOR_VERIFY, {
          state: { email, returnTo },
        });
      } catch (error: any) {
        showError(error);
      } finally {
        setLoading(false);
      }
    },
    [navigation]
  );

  const handleRegisterClick = () => {
    navigation(AppRoutes.DONOR.DONOR_REGISTER, {
      state: { returnTo },
    });
  };

  return (
    <>
      <div className={styles.container}>
        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.header}>
            <p className={styles.logo}>Donor Login</p>
            <p className={styles.description}>
              Please use your credentials to login
            </p>
          </div>
          <div className={styles.formControls}>
            <Input
              fullWidth
              label="Email"
              placeholder="Enter your email"
              {...register(LoginInputs.EMAIL)}
              error={!!errors[LoginInputs.EMAIL]}
              helperText={errors[LoginInputs.EMAIL]?.message}
            />
          </div>
          <Button
            type="submit"
            fullWidth
            sx={{ mt: 3 }}
            disabled={loading}
            startIcon={loading ? <CircularIndeterminate size={20} /> : null}
          >
            {loading ? <AnimatedDots text="Sending OTP" /> : "Send OTP"}
          </Button>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
            }}
          >
            {/* <Box sx={{ mt: 1 }}>
              Don&apos;t have an account?
              <Button
                variant="text"
                sx={{ p: 0, minWidth: "auto", textTransform: "none" }}
                onClick={handleRegisterClick}
              >
                Register
              </Button>
            </Box> */}
          </Box>
        </form>
      </div>
    </>
  );
};

export default DonorLogin;
